module.exports = __webpack_public_path__ + "img/borrower_benefit_hero_mobile.4e1c8cc3.jpg";